async function fetchAllManuals() {
  const allManuals = [];
  let page = 1;
 
  while (true) {
    try {
      const res = await fetch(`/pages/product-manual-index?page=${page}`);
      if (!res.ok) break;
 
      const data = await res.json();
      if (!Array.isArray(data) || data.length === 0) break;
 
      allManuals.push(...data);
      page++;
    } catch (err) {
      console.error(`Error on page ${page}:`, err);
      break;
    }
  }
  // const lowerTerm = term.toLowerCase();
  // return allManuals.filter(p =>
  //   p.title.toLowerCase().includes(lowerTerm)
  // );
 
  return allManuals;
}
 
 
(function () {
  const input = document.getElementById("product-input");
  const suggestionsBox = document.getElementById("suggestions");
  const langSelect = document.getElementById("lang-select");
  const productTitle = document.getElementById("product-title");
  const manualsWrapper = document.getElementById("manuals-wrapper");
  const emptyManuals = document.getElementById("manuals-empty");
 
  let allProducts = [];
  let currentData = null;
  let selectedLang = langSelect.value;
 
  manualsWrapper.style.display = "none";
  emptyManuals.style.display = "none";
 
  langSelect.addEventListener("change", () => {
    selectedLang = langSelect.value;
    if (currentData) renderManuals(currentData);
  });
 
    var allManuals = [];
  fetchAllManuals().then(manuals =>{
    allManuals = manuals;
  });
 
 
  input.addEventListener("input", async (e) => {
    suggestionsBox.innerHTML = "";
    productTitle.textContent = "";
    manualsWrapper.style.display = "none";
    emptyManuals.style.display = "none";
 
    console.log("in input called");
    const term = e.target.value;
 
    console.log(term);
    if (term.length < 1) {
      suggestionsBox.innerHTML = "";
      return;
    }
   console.log(allManuals);
 
    const matches = allManuals.filter(p =>
      p.title.toLowerCase().includes(term)
    );
      // fetchAllManuals(term).then(matches  => {
          if (matches.length > 0) {
            suggestionsBox.innerHTML = matches.map(p =>
              `<li>
<button type="button" data-handle="${p.handle}" class="suggestion-item">
<h3>${p.title}</h3>
</button>
</li>`
            ).join("");
          }
     // });
 
    
  //  console.log(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product`);
  //  console.log(`/search.json?q=${encodeURIComponent(term)}`);
    //const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product`);
       // const res = await fetch(`/search.json?q=${encodeURIComponent(term)}`);
 
   // const json = await res.json();
   // const products = json.resources.results.products || [];
 
  });
 
  suggestionsBox.addEventListener("click", async (e) => {
    const button = e.target.closest(".suggestion-item");
    if (!button) return;
    const handle = button.dataset.handle;
 
    if (!handle) return;
 
    suggestionsBox.innerHTML = "";
   // input.value = e.target.textContent;
 
    const res = await fetch(`/products/${handle}?view=manuals`);
    const data = await res.json();
 
    if (!data.manuals || data.manuals.length === 0) {
      manualsWrapper.style.display = "none";
      emptyManuals.style.display = "block";
      return;
    }
 
    currentData = data;
    emptyManuals.style.display = "none";
    manualsWrapper.style.display = "block";
    renderManuals(data);
  });
 
  function renderManuals(data) {
    console.log(productTitle);
    productTitle.textContent = data.title;
    const container = document.getElementById("manuals-container");
    container.innerHTML = "";
    console.log(document.getElementById("product-title").textContent);
 
    console.log(data);
    data.manuals.forEach(section => {
      const sectionTitle = selectedLang === "ko" ? section.section_title_ko : section.section_title_en;
 
          const accordionItem = document.createElement("div");
          accordionItem.classList.add("accordion-item");
          accordionItem.innerHTML = `
<div class="accordion-heading">
              ${sectionTitle}
<em class="accordion-icon">
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 5" aria-label="ChevronDown2" class="Accordion_trigger-icon__GX62o">
<path d="M.397.972a.479.479 0 0 1 .67-.684L4.5 3.658 7.932.288a.479.479 0 0 1 .671.684L4.5 5 .397.972Z" clip-rule="evenodd"></path>
</svg>
</em>
</div>
<div class="accordion-content accordion-link-content" style="display: none;">
<ul>
                ${section.downloads.map(file => {
                  const title = selectedLang === "ko" ? file.file_title_ko : file.file_title_en;
                  const url = selectedLang === "ko" ? file.file_url_ko : file.file_url_en;
                  return `
<li>
<a class="accordion-link" rel="noreferrer noopener" target="_blank" href="${url}">
                        ${title}
<svg viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="ChevronRight2">
<path clip-rule="evenodd" d="M.972 8.603a.479.479 0 0 1-.684-.67L3.658 4.5.288 1.068A.479.479 0 1 1 .972.397L5 4.5.972 8.603Z"></path>
</svg>
</a>
</li>
                  `;
                }).join("")}
</ul>
</div>
          `;
      accordionItem.querySelector(".accordion-heading").addEventListener("click", function () {
        const allItems = accordionItem.parentElement.querySelectorAll(".accordion-item");
        const content = accordionItem.querySelector(".accordion-content");
        // Toggle current
        accordionItem.classList.toggle("active");
        content.style.display = content.style.display === "block" ? "none" : "block";
        // Close others
        allItems.forEach((item) => {
          if (item !== accordionItem) {
            item.classList.remove("active");
            item.querySelector(".accordion-content").style.display = "none";
          }
        });
      });
          container.appendChild(accordionItem);
    });
  }
})();